import { CommonModule } from '@angular/common';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-drop-input-file',
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './drop-input-file.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./drop-input-file.scss'],
})
export class DropInputFile {
  // allow 1 or multiple files to be selected
  multiple = input<boolean>(false);
  // set restrictions on which MIME types are acceptable
  allowedTypes = input.required<string[]>();
  disabled = input<boolean>(false);

  // dummy emitter, do what you like here
  choosenFiles = output<File[]>();

  onKeydown(event: KeyboardEvent, fileInput: HTMLInputElement) {
    if (this.disabled()) {
      return;
    }

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      fileInput.click();
    }
  }

  // validate what was dropped
  onDropped(e: Event) {
    e.preventDefault();
    if (this.disabled()) {
      return;
    }

    const dragEvent = e as DragEvent;
    const files = dragEvent.dataTransfer?.files ? Array.from(dragEvent.dataTransfer!.files) : [];

    if (files.length === 0) {
      return;
    }

    const multiple = this.multiple();
    if (!multiple && files.length > 1) {
      console.warn('More than one file dropped');
      return;
    }

    const allowedTypes = this.allowedTypes();
    const errors = files.reduce((errs, file) => {
      return allowedTypes.includes(file.type)
        ? errs
        : errs.concat(
            `File ${file.name} is of an invalid type, expected one of ${allowedTypes.join(', ')}`,
          );
    }, [] as string[]);

    if (errors.length > 0) {
      errors.forEach((e) => console.warn(e));
      return;
    }

    this.choosenFiles.emit(files);
  }

  // almost no validation is needed here
  onSelected(e: Event) {
    if (this.disabled()) {
      return;
    }

    const target = e.target as HTMLInputElement;
    if (!target.files) {
      return;
    }

    const files = Array.from(target.files);
    this.choosenFiles.emit(files);

    // Reset the input value so the same file can be selected again.
    target.value = '';
  }
}
